// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JO9wzFToNqwui1VYDYn4{flex-direction:column;align-items:flex-start;display:flex}.maUUIPRVmcMYEB7MoilS{text-decoration:none;padding:0!important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `JO9wzFToNqwui1VYDYn4`,
	"learnMoreBtn": `maUUIPRVmcMYEB7MoilS`
};
export default ___CSS_LOADER_EXPORT___;
